module.exports = "../img/DataFiscal.jpg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/DataFiscal.jpg
// module id = 30
// module chunks = 0